import {
  CandidateProfileMoreHotspot,
  CandidateProfileOverviewHotspot,
  IntegrationKinds,
  OfferPromoteJobBoardsHotspot,
  Partner,
} from '@recruitee/integrations/types';
import { createActions, ngrxEvent } from '@recruitee/ngrx';

const IntegrationEventActions = createActions('Integrations', {
  JobBoardPostingCreated: ngrxEvent<{
    context: {
      hotspot: OfferPromoteJobBoardsHotspot;
      integrationKind: IntegrationKinds;
    };
  }>(),
  JobBoardPostingEdited: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot; integrationKind: IntegrationKinds };
  }>(),
  JobBoardPostingDeleted: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot; integrationKind: IntegrationKinds };
  }>(),
  MailboxLinkInsertedEvent: ngrxEvent<{ context: { integrationKind: IntegrationKinds } }>(),
  VideoCallScheduledEvent: ngrxEvent<{ context: { integrationKind: IntegrationKinds } }>(),
  AccountConnectedEvent: ngrxEvent<{ context: { integrationKind: IntegrationKinds } }>(),
  IntegratedEvent: ngrxEvent<{
    context: { integrationKind?: IntegrationKinds; partner?: Partner };
  }>(),
  DisintegratedEvent: ngrxEvent<{
    context: { integrationKind?: IntegrationKinds; partner?: Partner };
  }>(),
  ElectronicSignatureRequestSentToCandidateEvent: ngrxEvent<{
    context: {
      hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot;
      integrationKind: IntegrationKinds;
    };
  }>(),
  ElectronicSignatureRequestRemovedEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot; integrationKind: IntegrationKinds };
  }>(),
  CandidateSentToPartnerEvent: ngrxEvent<{
    context: {
      hotspot: CandidateProfileMoreHotspot | CandidateProfileOverviewHotspot;
      integrationKind: IntegrationKinds;
      partner?: Partner;
    };
  }>(),
  ReportUpdatedEvent: ngrxEvent<{
    context: {
      hotspot: CandidateProfileMoreHotspot | CandidateProfileOverviewHotspot;
      integrationKind: IntegrationKinds;
      partner?: Partner;
    };
  }>(),
  HotelprofessionalsPostingCreated: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  HotelprofessionalsPostingEdited: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  HotelprofessionalsPostingDeleted: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  WerkenInEenHotelPostingCreated: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  WerkenInEenHotelPostingEdited: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  WerkenInEenHotelPostingDeleted: ngrxEvent<{
    context: { hotspot: OfferPromoteJobBoardsHotspot };
  }>(),
  AppicalCandidateSentEvent: ngrxEvent<{ context: { hotspot: CandidateProfileMoreHotspot } }>(),
  BryqReportCreatedEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  InterviewMochaReportCreatedEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  InterviewMochaEmailSentEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  TestDomeReportCreatedEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  CodilityReportCreatedEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  CodilityCodeLiveEmailSentEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  PersonioCandidateSentEvent: ngrxEvent<{ context: { hotspot: CandidateProfileMoreHotspot } }>(),
  BambooCandidateSentEvent: ngrxEvent<{ context: { hotspot: CandidateProfileMoreHotspot } }>(),
  CheckrBackgroundCheckRequestSuccessEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  CheckrInvitationCancelledEvent: ngrxEvent<{
    context: { hotspot: CandidateProfileOverviewHotspot | CandidateProfileMoreHotspot };
  }>(),
  IntegrationUpdatedEvent: ngrxEvent<{
    uid: string;
  }>(),
  IntegrationRemovedEvent: ngrxEvent<{
    uid: string;
  }>(),
});

export { IntegrationEventActions };
